export const caseStudyImages = {
    hero: {
        iot:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/iot-hero.webp",
        ai:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/ai-hero.webp",
        cloud:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/cloud-hero.webp",
        devops:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/business-intelligence-hero.webp",
        testing:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/automationtest-engineer-hero.webp",
        ml:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/machinelearning-engineer-hero.webp",
        blockchain:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/blockchain-developer-hero.webp",
        crossplatform:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/devops-engineer-hero.webp",
        androidapp:
            "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/flutter-developer-hero.webp",
    },
};
